/* eslint-disable */
import { StyleSheet } from 'react-native'

export default StyleSheet.create({
  container: {
    flex: 1
  },
  icons: {
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 10,
    flex: 1,
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    // backgroundColor: 'red',
    // height: 10
  }
})
